class ItemTabelasService extends AbstractService
  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/item-tabela'
    configs.callFunction = {
      method: 'PUT',
      holder: 'function'
    }

  removerExcecaoConfirmada: (item, callback, options) ->
    @callFunction('remove-excecoes', {item: item}, callback, options)

angular.module('eficienciaFiscalModule').service('itemTabelasService', ItemTabelasService)
